import React, { useState, useRef, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
} from "reactstrap"
import { post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { useNavigate } from "react-router-dom"
import Loader from "common/loader"
import {
  ADD_ARTICLES,
  LANGUAGES_SEARCH,
  UPLOAD_FILE,
} from "helpers/api_endpoints"

document.title = "Create Article"

function CreateArticle() {
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState("")
  const [status, setStatus] = useState(1)
  const [named, setNamed] = useState({ title: [] })
  const [image, setImage] = useState("")
  const [selectedFile, setSelectedFile] = useState(null)
  const fileInputRef = useRef(null)
  const [articalePharagraph, setArticalePharagraph] = useState([])
  const [languages, setLanguages] = useState([])
  const [errorMsg, seterrorMsg] = useState("")
  const navigate = useNavigate()

  useEffect(() => {
    // Fetch available languages
    post(`${LANGUAGES_SEARCH}`, { status: 1 })
      .then(response => {
        setLanguages(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const handleSubmit = e => {
    e.preventDefault()
    if (errorMsg) {
    return
  }
    setLoading(true)

    const paragraphs = articalePharagraph.map(p => ({
      ...p,
      name: p.named ? JSON.stringify(p.named) : "",
      content: p.contented ? JSON.stringify(p.contented) : "",
    }))

    const formData = {
      name: JSON.stringify(named),
      status,
      image,
      named,
      ArticleParagraphs: paragraphs,
    }

    post(ADD_ARTICLES, formData)
      .then(response => {
        if (response.code === 201) {
          navigate("/articles", {
            state: { successMsg: "Article Created Successfully" },
          })
        }
      })
      .catch(error => {
        console.error("Error creating article:", error)
        seterrorMsg("Failed to create article. Please try again.")
      })
      .finally(() => setLoading(false))
  }

  const handleName = (languageId, value) => {
    if (!named.title) {
      setNamed({ title: [{ [languageId]: value }] })
      return
    }

    const ln = named.title.find(el => Object.keys(el)[0] == languageId)
    if (!ln) {
      named.title.push({ [languageId]: value })
    } else {
      ln[languageId] = value
    }
    setName(JSON.stringify(named))
  }

  const handleFileUpload = event => {
    const file = event.target.files[0]
    if (!file) return

    if (file.size > 1 * 1024 * 1024) {
      seterrorMsg("File size is larger than 1MB")
      setSelectedFile(null)
      setImage("")
      if (fileInputRef.current) fileInputRef.current.value = ""
      return
    }
    if (file.type !== "image/jpeg" && file.type !== "image/png") {
      seterrorMsg("Only JPEG or PNG images are allowed")
      setSelectedFile(null)
      if (fileInputRef.current) fileInputRef.current.value = ""
      return
    }
    seterrorMsg("")
    setSelectedFile(file)

    post(
      UPLOAD_FILE,
      { file, type: "article_image", fullPath: "true" },
      { headers: { "Content-Type": "multipart/form-data" } }
    )
      .then(response => {
        const data = response.data
        setImage(data.path)
      })
      .catch(error => {
        console.error("Upload error:", error)
        seterrorMsg("File upload failed.")
        setSelectedFile(null)
      })
  }

  const clearPhoto = () => {
    setSelectedFile(null)
    setImage("")
    seterrorMsg("")
    if (fileInputRef.current) fileInputRef.current.value = ""
  }

  const clearParagraphPhoto = index => {
    setArticalePharagraph(prev => {
      const updated = [...prev]
      updated[index].image = null
      return updated
    })
  }

  const handleParagraphImage = async (index, file) => {
    if (!file) return
    try {
      const response = await post(
        UPLOAD_FILE,
        { file, type: "paragraph_image", fullPath: "true" },
        { headers: { "Content-Type": "multipart/form-data" } }
      )

      setArticalePharagraph(prev => {
        const updated = [...prev]
        updated[index].image = response.data.path
        return updated
      })
    } catch (err) {
      console.error("Paragraph Image Upload Error:", err)
    }
  }

  const deleteParagraph = index => {
    setArticalePharagraph(prev => prev.filter((_, i) => i !== index))
  }

  const addNewParagraph = () => {
    setArticalePharagraph(prev => [
      ...prev,
      {
        id: null,
        name: "",
        content: "",
        image: null,
        named: { title: [] }, // Multilingual name/title
        contented: { title: [] }, // Added Multilingual content field
      },
    ])
  }

  const getLanguageValue = langId => {
    const item = named.title?.find(obj => obj[langId] !== undefined)
    return item ? item[langId] : ""
  }

  const getParagraphLangValue = (paragraph, langId, field = "named") => {
    const data = paragraph[field]
    if (!data || !data.title || !Array.isArray(data.title)) return ""
    const item = data.title.find(obj => obj[langId] !== undefined)
    return item ? item[langId] : ""
  }

  const handleParagraphLangChange = (index, langId, value, field) => {
    setArticalePharagraph(prev => {
      const updated = [...prev]
      const paragraph = { ...(updated[index] || {}) }

      const targetField = paragraph[field] || { title: [] }
      if (!Array.isArray(targetField.title)) targetField.title = []

      const arr = [...targetField.title]
      const key = String(langId)
      const i = arr.findIndex(obj => obj && obj.hasOwnProperty(key))

      if (i === -1) arr.push({ [key]: value })
      else arr[i] = { [key]: value }

      targetField.title = arr
      paragraph[field] = targetField
      updated[index] = paragraph
      return updated
    })
  }

  const handleParagraphContentChange = (index, langId, value) => {
    handleParagraphLangChange(index, langId, value, "contented")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Articles" breadcrumbItem="Create Article" />
          <Form className="form-horizontal" onSubmit={handleSubmit}>
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    {errorMsg && <Alert color="danger">{errorMsg}</Alert>}

                    {languages.map(lang => (
                      <Row key={lang.id}>
                        <div className="form-group col-md-4 mt-2">
                          <Label className="form-label">
                            <Trans>Name ({lang.name})</Trans>
                          </Label>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            value={getLanguageValue(lang.id)}
                            onChange={e => handleName(lang.id, e.target.value)}
                            required={lang.id === 1 || lang.id === 2}
                          />
                        </div>
                      </Row>
                    ))}

                    <div className="form-group col-md-4 mt-2">
                      <Label className="form-label">
                        <Trans>Status</Trans>
                      </Label>
                      <select
                        className="form-control"
                        onChange={e => setStatus(e.target.value)}
                        value={status}
                        required
                      >
                        <option value="">Select Status</option>
                        <option value={1}>Active</option>
                        <option value={0}>Non Active</option>
                      </select>
                    </div>

                    <div className="form-group col-md-4 mt-2">
                      <Label className="form-label">
                        <Trans>Main Image</Trans>
                      </Label>
                      <Input
                        type="file"
                        onChange={handleFileUpload}
                        required={!image && !selectedFile}
                      />
                    </div>

                    {(selectedFile || image) && (
                      <div className="mt-2">
                        <button
                          type="button"
                          className="btn btn-danger mb-2 mx-2"
                          onClick={() => clearPhoto()}
                        >
                          Remove Image
                        </button>
                        <img
                          src={
                            selectedFile
                              ? URL.createObjectURL(selectedFile)
                              : image
                          }
                          width="500"
                          height="500"
                          alt="Preview"
                        />
                      </div>
                    )}

                    <Row className="mt-4">
                      <h4>Article Paragraphs</h4>
                      <Button
                        color="primary"
                        className="mb-3"
                        onClick={addNewParagraph}
                      >
                        + Add Paragraph
                      </Button>

                      {articalePharagraph.map((item, index) => (
                        <Card key={index} className="mb-3">
                          <CardBody>
                            <div className="d-flex justify-content-end">
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => deleteParagraph(index)}
                              >
                                Delete Paragraph
                              </Button>
                            </div>

                            <Row>
                              {languages.map(lang => (
                                <Col
                                  md={4}
                                  key={`para-name-${index}-lang-${lang.id}`}
                                  className="mt-2"
                                >
                                  <Label>Title {lang.name}</Label>
                                  <Input
                                    type="text"
                                    value={getParagraphLangValue(
                                      item,
                                      lang.id,
                                      "named"
                                    )}
                                    onChange={e =>
                                      handleParagraphLangChange(
                                        index,
                                        lang.id,
                                        e.target.value,
                                        "named"
                                      )
                                    }
                                  />
                                </Col>
                              ))}
                            </Row>

                            <Row>
                              {languages.map(lang => (
                                <Col
                                  md={4}
                                  key={`para-content-${index}-lang-${lang.id}`}
                                  className="mt-2"
                                >
                                  <Label>Content ({lang.name})</Label>
                                  <Input
                                    type="textarea"
                                    value={getParagraphLangValue(
                                      item,
                                      lang.id,
                                      "contented"
                                    )}
                                    onChange={e =>
                                      handleParagraphLangChange(
                                        index,
                                        lang.id,
                                        e.target.value,
                                        "contented"
                                      )
                                    }
                                  />
                                </Col>
                              ))}
                            </Row>

                            <Row>
                              <Col md={4} className="mt-3">
                                <Label>Paragraph Image</Label>
                                <Input
                                  type="file"
                                  onChange={e =>
                                    handleParagraphImage(
                                      index,
                                      e.target.files[0]
                                    )
                                  }
                                />
                              </Col>

                              <Col md={4} className="mt-3">
                                {item.image && (
                                  <div className="mt-2">
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm mb-2"
                                      onClick={() => clearParagraphPhoto(index)}
                                    >
                                      Remove Image
                                    </button>
                                    <img
                                      src={item.image}
                                      alt="paragraph"
                                      width="500"
                                      height="500"
                                    />
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      ))}
                    </Row>

                    <div className="text-center mt-4">
                      <Button type="submit" color="danger" disabled={loading}>
                        {loading ? (
                          <Trans>Loading...</Trans>
                        ) : (
                          <Trans>Submit</Trans>
                        )}
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default CreateArticle
